import React from 'react';

/**
 * The Saf3AI Agent's own mark: a large and a small four-point spark, the common sign for an AI
 * assistant, so the Agent no longer shares the lightning glyph other modules used. Filled with
 * `currentColor`, so it takes the colour of whatever holds it (white on the sidebar's pill).
 * Decorative: the label beside it names the Agent.
 */
const AgentMark = ({ size = 18, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={className}
    fill="currentColor"
    aria-hidden="true"
    focusable="false"
    data-mark="saf3ai-agent"
  >
    <path d="M10 1.5c.5 4.6 3.4 7.5 8 8-4.6.5-7.5 3.4-8 8-.5-4.6-3.4-7.5-8-8 4.6-.5 7.5-3.4 8-8Z" />
    <path d="M18.5 13c.3 2.6 1.9 4.2 4.5 4.5-2.6.3-4.2 1.9-4.5 4.5-.3-2.6-1.9-4.2-4.5-4.5 2.6-.3 4.2-1.9 4.5-4.5Z" opacity="0.85" />
  </svg>
);

export default AgentMark;
